
<template>
<div class="welcome-container">
  <!--div class="earth"></div-->
  <div class="text-stuff">
    <h2 class="greetings">Welcome to HBR Competencies!</h2>
    <p>Select any module below to begin a service-line lesson and quiz.</p>
    <div><UpNext /></div>
  </div>
</div>
</template>

<script>
import UpNext from "./UpNext.vue"
import store from '@/store';

export default {
  name: 'Welcome',
  components:{
    UpNext
  },
  props: {
    user: Object,
    claims: Object
  },
  methods: {
    handleLessonRoute() {
      store.commit('modulePage');
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/global-styles/variables.scss';

.earth {
  background: rgba(black, 0.1);
  width: 140px;
  height: 140px;
  margin-right: $gap;
  border-radius: 100%;
  background-image: url('../../assets/gifs/earth.gif');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.welcome-container {
    text-align: left;
    padding: $gap;
    //border: 2px solid #ff722211;
    border-radius: $rad;
    display: flex;
}

.continue-button {
    background: $colorOrange;
    width: max-content;
    color: white;
    padding: 8px 24px;
    border-radius: calc(#{$rad} * 2);
    cursor: pointer;
    transition: $animationSpeed;
    border: 2px solid $colorOrange;
    font-weight: bold;
     
    strong {
      padding-left: 8px;
      transition: padding 300ms;
    }

    &:hover {
        background: transparent;
        color: $colorOrange;

        strong {
          padding-left: 8px;
        }
    }
}

h2 {
    color: $colorBlue;
    margin-top: -6px;
}

p {
    margin: 24px 0px 24px 0px;
}
</style>